'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'question';
var width = 320;
var height = 512;
var aliases = [10067,10068,61736];
var unicode = '3f';
var svgPathData = ['', 'M16 160C16 80.5 80.5 16 160 16S304 80.5 304 160c0 49.7-25.9 98.1-72 124.7l-76 43.9-4 2.3 0 77.1 16 0 0-67.9 72-41.6c51.3-29.6 79.9-83.3 80-138.6l0 0C320 71.6 248.4 0 160 0S0 71.6 0 160l0 8 16 0 0-8zM172 504l0-24-24 0 0 24 24 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;